import DraftChargesList from "./DraftChargesList";
import DraftChargesCreate from "./DraftChargesCreate";

export default {
    list: DraftChargesList,
    create: DraftChargesCreate
};
